import { Map } from 'ol';
import React, { useEffect, useRef } from 'react';

export type BgisMapProps = {
  id?: string | undefined;
  map?: Map;
};

/**
 * Renders the placeholder for the map.
 * @param props
 * @returns The div tag into which the provided map is rendered.
 */
export const BgisMap: React.FC<BgisMapProps> = (props: BgisMapProps) => {
  const { id, map } = props;

  const mapRef = useRef(null);

  useEffect(() => {
    let ref = mapRef.current;
    if (id !== undefined) {
      map?.setTarget(id); // set the map target to the element id
    } else if (ref !== null && map !== undefined) {
      map?.setTarget(ref); // set the map target to the ref
    }
    return () => {
      // cleanup by setting the target to undefined.
      map?.setTarget(undefined);
    };
  }, [map,id]); // only watch for changes of the id (if any)

  return <div ref={mapRef} {...(id !== undefined && { id: id })} className="bgis-map" />;
};
